const experience = [
  {
    "slug": "sauna-by-wordware",
    "role": "AI Engineer, Agent Intelligence",
    "company": "Sauna by Wordware (YC S24)",
    "period": "Sep 2026 - Current",
    "summary": "Teaching Sauna, an AI coworker, to think, remember, and act on your behalf.",
    "description": "AI Engineer on the Agent Intelligence team at Sauna by Wordware (YC S24). I work on the core agent - how it reasons, what it remembers, and how it acts across the tools people already use - with a focus on making Sauna proactive, so useful work shows up before you ask for it.",
    "details": "",
    "outcomes": [
      "Building Sauna's proactive layer - the agent notices what needs attention across connected apps like email and calendar, ranks it, and turns it into ready-to-approve suggestions, drafts, and reminders.",
      "Extended how Sauna reaches people, including proactive check-ins over iMessage.",
      "Shipped managed data and decision-model APIs, each paired with an agent skill so Sauna can call them directly.",
      "Working across the agent loop, prompts, model routing, and context and memory efficiency, with an eye on speed, cost, and quality."
    ],
    "metrics": [
      "50+ pull requests merged in the first month, end to end from agent logic to product surface."
    ],
    "link": "https://sauna.ai/",
    "links": {
      "company": "https://sauna.ai/"
    }
  },
  {
    "slug": "minerva-intelligence-ycx25",
    "role": "Founding Engineer, First Hire",
    "company": "Minerva Intelligence (YCX25)",
    "period": "Jun 2025 - Aug 2026",
    "summary": "Built the AI accountant as founding engineer and first hire.",
    "description": "Founding engineer and first hire at Minerva Intelligence (YCX25), the AI accountant. Built the AI-powered accounting platform and Mars, Minerva's AI-native accounting firm, from the ground up.",
    "details": "",
    "outcomes": [
      "Shipped early platform architecture spanning ingestion, reasoning, and analyst workflow layers.",
      "Defined engineering standards and release process for the initial product team.",
      "Partnered directly with founders to scope roadmap from customer discovery to production features."
    ],
    "metrics": [
      "Built and launched the first production stack as employee #1.",
      "Reduced feature delivery cycle through reusable service patterns and internal tooling."
    ],
    "link": "https://www.tryminerva.ai/",
    "links": {
      "company": "https://www.tryminerva.ai/"
    }
  },
  {
    "slug": "brightlight-health",
    "role": "AI/ML Engineer",
    "company": "Brightlight Health",
    "period": "2025 - 2026",
    "summary": "Built AI features for a clinic EMR, from scheduling to supervisor chart review.",
    "description": "Engineered AI-powered EMR features for allied-health clinics. Built an imitation-learning prototype around the supervisor chart-review workflow, with a privacy-safe dataset pipeline, leakage-free offline evaluation, and a shadow-mode continual learner wired into live routes.",
    "details": "",
    "outcomes": [
      "Shipped a privacy-safe imitation-learning pipeline that predicts supervisor review actions without touching PHI.",
      "Built leakage-free offline evaluation with safety-first metrics before any live exposure.",
      "Deployed a shadow-mode continual-learning loop, inert by default and gated on data-retention sign-off."
    ],
    "metrics": [
      "Honest offline result reported against a strong reviewer-score baseline.",
      "Read-only data access with salted-hash identifiers end to end."
    ],
    "link": "https://www.brightlight.health/",
    "links": {
      "company": "https://www.brightlight.health/"
    }
  },
  {
    "slug": "lexius",
    "role": "CV/ML Intern",
    "company": "Lexius (YCW2026)",
    "period": "2024",
    "summary": "Improved production video classification quality and metrics.",
    "description": "Improved video classification by 5% accuracy and 19% F1-score. Migrated GCP to AWS. Built microservices for model serving.",
    "details": "",
    "outcomes": [
      "Improved model quality through targeted dataset cleanup and evaluation instrumentation.",
      "Migrated key workloads from GCP to AWS with lower inference variance.",
      "Delivered service endpoints that supported faster model iteration and deployment."
    ],
    "metrics": [
      "+5% classification accuracy.",
      "+19% F1-score on production-like validation data.",
      "Lower mean inference latency after migration and service tuning."
    ],
    "link": "https://www.lexius.ai/",
    "links": {
      "company": "https://www.lexius.ai/"
    }
  },
  {
    "slug": "ai-racing-tech",
    "role": "Simulation & Perception Researcher",
    "company": "AI Racing Tech (UC Berkeley)",
    "period": "2023-2024",
    "summary": "Worked on autonomy stack simulation and CI for racing systems.",
    "description": "Indy Autonomous Challenge. Integrated vehicle dynamics, built Azure CI pipelines for ROS2 autonomy stack. Pure Pursuit and Model-Based Control.",
    "details": "",
    "outcomes": [
      "Integrated dynamics and perception modules into a consistent simulation workflow.",
      "Added CI coverage for autonomy stack regressions using Azure pipelines.",
      "Improved controller testing confidence before hardware track runs."
    ],
    "metrics": [
      "Reduced integration regressions through automated ROS2 validation checks.",
      "Shortened simulation-to-test iteration loop for autonomy experiments."
    ],
    "link": "",
    "links": {}
  },
  {
    "slug": "berkeley-speech-group",
    "role": "LLM Poker Researcher",
    "company": "Berkeley AI Research (BAIR)",
    "period": "2023",
    "summary": "Trained and evaluated an LLM poker decision system.",
    "description": "LLM poker agent using LLaMA3 with custom loss. SFT pipeline with 20% increase in decision accuracy. Gemini and GPT-4 integration.",
    "details": "",
    "outcomes": [
      "Built supervised fine-tuning pipeline tailored to poker decision trajectories.",
      "Tested strategy improvements using custom objective and evaluation harnesses.",
      "Integrated external model APIs for comparative baseline analysis."
    ],
    "metrics": [
      "+20% decision accuracy improvement over baseline policy.",
      "Stable training behavior across multiple opponent strategy sets."
    ],
    "link": "",
    "links": {}
  }
];

export default experience;
